import styled from "styled-components";

import { media } from "../../../styles/media";

export const DataTableStyles = styled.div`
  .dataTable-head {
    display: flex;
    align-items: center;
    background: ${({ theme }) => theme.colors.semantic.container.gray};
    border-bottom: 1px solid ${({ theme }) => theme.colors.semantic.separator};
    padding: ${({ theme }) => theme.spacing[12]} ${({ theme }) => theme.spacing[24]};
  }

  .dataTable-headCell {
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
    letter-spacing: 0.1px;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
  }

  & > div:last-child {
    border-radius: 0 0 ${({ theme }) => theme.radius[12]} ${({ theme }) => theme.radius[12]};
    overflow: hidden;
  }

  & > div:not(.dataTable-head):not(.dataTable-empty) {
    transition: background 0.15s ease;

    &:hover {
      background: ${({ $disableHover, theme }) =>
        $disableHover ? "transparent" : theme.colors.accent[50]};
    }
  }

  .dataTable-empty {
    text-align: center;
    padding: ${({ theme }) => theme.spacing[40]} 0;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    font-size: 14px;
  }

  @keyframes rowDelete {
    to {
      opacity: 0;
      transform: translateX(-30px);
    }
  }

  .row-deleting {
    animation: rowDelete 0.3s ease forwards;
    pointer-events: none;
  }

  /* Fixed-width columns overflow narrow screens and crush the flex column to
     nothing (the manager's name wrapped one letter per line). Below the tablet
     breakpoint scroll the table horizontally and give the head + rows a
     min-width so the columns keep usable, aligned sizes. */
  ${media.maxTablet`
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    .dataTable-head {
      min-width: var(--dt-min-width, 640px);
    }

    & > div:not(.dataTable-head):not(.dataTable-empty) {
      min-width: var(--dt-min-width, 640px);
    }
  `}
`;
